module.exports = __webpack_public_path__ + "img/topic-nodeseados.48ea8bf2.svg";